import { Eye } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

/**
 * Striscia informativa per il sotto-utente con ruolo `vedi-sito`.
 *
 * Il ruolo promette "solo visualizzazione", ma il catalogo continua a
 * mostrargli un "Aggiungi al carrello" grande e blu su ogni prodotto:
 * disabilitarlo vorrebbe dire toccare una decina di call site sparsi su
 * sette file, e lasciarlo com'è vorrebbe dire far scoprire il limite solo
 * al click. Questa striscia lo dice una volta, in alto, su ogni pagina —
 * il rifiuto vero resta in `CartContext.addItem` (toast) e nel backend
 * (`PUT /api/clienti/me/cart` → 403).
 *
 * Non è sticky di proposito: l'unico banner fisso è quello di
 * impersonazione, che coordina la propria altezza con l'header tramite
 * `--impersonation-banner-h`. Qui non serve competere per quello spazio.
 */
export function ReadOnlyOperatoreBanner() {
  const { user, canAddToCart } = useAuth();

  if (user?.ruolo !== 'cliente_subordinato' || canAddToCart) return null;

  return (
    <div
      className="w-full bg-amber-50 border-b border-amber-200 px-4 py-2.5"
      data-testid="readonly-operatore-banner"
      role="status"
    >
      <div className="max-w-6xl mx-auto flex items-start gap-2 text-[13px] leading-relaxed text-amber-900">
        <Eye className="w-4 h-4 flex-shrink-0 mt-0.5 text-amber-600" />
        <p>
          <span className="font-semibold">Profilo di sola visualizzazione.</span>{' '}
          Puoi consultare catalogo, prezzi e documenti dell&apos;azienda, ma non
          aggiungere prodotti al carrello. Per ordinare, chiedi al titolare
          dell&apos;account un ruolo diverso.
        </p>
      </div>
    </div>
  );
}
